"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VerticalSpacing = require("./VerticalSpacing");

var _VerticalSpacing2 = _interopRequireDefault(_VerticalSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VerticalSpacing2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-vertical-spacing/lib/index.js
// module id = 333
// module chunks = 0